<script>
import { authComputed, authMethods, orgComputed, orgMethods } from '@state/helpers';

export default {
  name: 'Logindesktop',
  components: {},
  props: {
    route: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      username: '',
      password: '',
      emailError: null,
      passError: null,
      authenticating: false
    };
  },
  mounted() {
    console.log(this.primaryColor)
  },
  methods: {
    ...authMethods,
    ...orgMethods,
    handleAuthErrors(err) {
      this.authenticating = false;
      this.emailError = '';
      this.passError = err;
    },
    formValid() {
      if (this.username && this.password) {
        return true;
      } else {
        if (!this.password || this.password === '') {
          this.passError = `Password can't be blank`;
        } else if (this.password.length < 8) {
          this.passError = `Password must be at least 8 characters`;
        }

        if (!this.username || this.username === '') {
          this.emailError = `Email can't be blank`;
        } else if (!this.username.includes('@')) {
          this.emailError = `A valid email address is required`;
        }
        return false;
      }
    },
    handleLogin() {
      if (this.formValid()) {
        this.authenticating = true;
        this.logIn({
          username: this.username,
          password: this.password,
        })
          .then((loginResponse) => {
            this.authenticating = false;

            this.$router.push(this.$route.query.redirectFrom || { name: 'home' });
          })
          .catch((err) => this.handleAuthErrors(err));
      }
    },
  },
  computed: {
    ...authComputed, ...orgComputed,
     colors() {
      return {
        '--color':  this.primaryColor
      }
    }
  },
  watch: {
    username(val) {
      if (this.emailError) {
        this.emailError = null;
      }
    },
    password(val) {
      if (this.passError) {
        this.passError = null;
      }
    },
  },
};
</script>

<template>

  <div class="container">
    <div class="header">
      <p class="title">
        Login
      </p>
      <p class="subtitle">
        Sign in to your account
      </p>
    </div>
    <div class="form">
      <form @submit.prevent="handleLogin">
        <BaseInputText
          :class="{ error: emailError }"
          autocomplete
          type="email"
          classStyle="user"
          placeholder="Email"
          v-model="username"
        />
        <p class="errorMsg" v-if="emailError">{{ emailError }}</p>

        <BaseInputText
          :class="{ error: passError }"
          autocomplete
          type="password"
          classStyle="password"
          placeholder="Password"
          v-model="password"
        />
        <p class="errorMsg" v-if="passError">{{ passError }}</p>

        <div class="forgot-password">
          <router-link class="btn-forgot-password" to="/reset-password">
            Forgot your password?
          </router-link>
        </div>
        <div>
          <div class="sign-in">
            <BaseButton class="large button" type="submit">
              <div v-if="authenticating === false">Sign In</div>
              <div v-else><b-spinner /></div>
            </BaseButton>
          </div>
          <!-- <div class="other-info">
            <p>
              Don't have an account?
              <router-link class="links" to="/signup">Sign Up</router-link>
            </p>
          </div> -->
          <div class="other-info">
            <p>
              By logging in, you agree to the
              <a class="links" target="_blank" :style="colors" href="/privacy">Privacy Policy</a>
              and
              <a class="links" target="_blank" :style="colors" href="/terms">Terms of Use.</a>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<style lang="scss">
@media (min-width: 576px) {
  .modal-sm {
    max-width: 375px;
  }
}
</style>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.container {
  align-items: center;
  background: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .header {
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
    text-align: center;
    width: 100%;

    .title {
      align-self: center;
      font-family: $base-font-family;
      font-size: 42px;
      height: 80px;
      line-height: 80px;
      margin-bottom: 0;
      margin-top: 30px;
    }

    .subtitle {
      align-self: center;
      font-family: $secondary-font-family;
      font-size: 16px;
      font-weight: normal;
      height: 14%;
      margin: 0;

      p {
        margin: 0;
      }
    }
  }

  .email-error,
  .pass-error {
    border-color: #fd5252;
    border-width: 0.2rem;
    margin-bottom: 1rem;
  }

  .form {
    display: block;
    height: 45%;
    margin: 0;
    margin-top: 4%;
    text-align: center;
    width: 100%;

    form {
      height: 100%;
      width: 100%;
      .input-wrapper {
        width: 100%;
        ::v-deep input {
          border-radius: unset;
          padding: 1.31% 5% 3.12% 14%;
          width: 100%;
          &.password {
            border-radius: unset;
            margin-bottom: 0.4rem;
          }
        }
        &.error {
          ::v-deep input {
            margin-bottom: unset;
          }
        }
      }
      .pass-error {
        margin-bottom: 4.8%;
        width: 80%;
      }

      .password {
        margin-bottom: 2.4%;
        width: 80%;
      }

      .forgot-password {
        margin-bottom: 60px;
        text-align: right;

        .btn-forgot-password {
          color: black;
          font-family: $secondary-font-family;
          font-weight: normal;
          text-decoration: none;
        }
      }

      .sign-in {
        align-self: flex-end;
        margin-left: 9%;
        width: 81.75%;
      }
      .errorMsg {
        border-color: #fd5252;
        border-width: 0.2rem;
        color: red;
        margin-bottom: 4.8%;
        margin-bottom: 1rem;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        width: 80%;
      }
    }
  }

  .other-info {
    font-family: $secondary-font-family;
    font-size: 16px;
    height: 25%;
    line-height: 1.4;
    margin: 0;
    margin-top: 10px;
    text-align: center;

    .links {
      color: var(--color);
      font-weight: normal;
      text-decoration: none;
    }
  }
}
</style>
